module.exports = __webpack_public_path__ + "img/green-circle-tick.6cd48cc.png";